import { AuditLogEvent } from '@seapoint/server/enums';
import { RefreshDataEventType } from 'PublicEntityTypes';
import { AuditLogView } from '../../types/entity-types';

export const isAuditLogEvent = (event: AuditLogView | RefreshDataEventType): event is AuditLogView => {
  return (
    event.type === AuditLogEvent.ACCOUNT_AND_TRANSACTION_SYNC ||
    event.type === AuditLogEvent.AI_PIPELINE ||
    event.type === AuditLogEvent.ACCOUNT_STATE_CHANGE ||
    event.type === AuditLogEvent.ACCOUNT_BALANCE_CHANGE ||
    event.type === AuditLogEvent.PAYMENT_STATUS_CHANGE ||
    event.type === AuditLogEvent.PAYMENT_EXTERNAL_LINKED ||
    event.type === AuditLogEvent.INVOICE_READER
  );
};
